<i18n
  src="@/locales/views/packing_house/process/exec_steps/show_exec_step.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/process_line_exec_step.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_input.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_output.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/process_line_exec_attr.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="this.routeName('show_step')"
      :params="{
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        process_line_step_id: this.process_line_step_id,
      }"
    ></go-back-link>

    <bread-crumbs
      :labels="[
        module_name,
        packing_house_process.name,
        process_line_step.name,
      ]"
    ></bread-crumbs>

    <div v-if="load_general_data" class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-slate-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.process_line_exec_step.executed_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(process_line_exec_step.executed_at) }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.process_line_exec_step.finished_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(process_line_exec_step.finished_at) }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.process_line_exec_step.process_line") }}
                </dt>
                <dd class="content-data">
                  {{ process_line_exec_step.process_line.name }}
                </dd>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4">
              <div class="sm:col-span-2">
                <dt class="label-data">
                  {{ $t("model.process_line_exec_step.observations") }}
                </dt>
                <dd class="content-data">
                  {{ process_line_exec_step.observations }}
                </dd>
              </div>
            </div>
            <hr />
            <div class="panel">
              <div class="panel-header">
                <h3 class="panel-header-title">Productos de entrada</h3>
              </div>
              <div class="panel-body">
                <div class="space-y-8 divide-y divide-slate-200">
                  <div
                    v-for="process_line_exec_input in process_line_exec_step.process_line_exec_inputs"
                    class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    :key="process_line_exec_input.id"
                  >
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{
                          $t(
                            "model.process_line_exec_input.process_line_product"
                          )
                        }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_input.process_line_product.name }}
                      </dd>
                    </div>
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.process_line_exec_input.input_code") }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_input.input_code }}
                      </dd>
                    </div>
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.process_line_exec_input.value") }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_input.value }}
                        {{ process_line_exec_input.unit }}
                      </dd>
                    </div>
                    <div></div>

                    <template v-if="process_line_exec_input.harvested_batch">
                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.harvested_batch.producer") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_input.harvested_batch.producer
                              .producer_code
                          }}
                          -
                          {{
                            process_line_exec_input.harvested_batch.producer
                              .fullname
                          }}
                        </dd>
                      </div>

                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.harvested_batch.crop_field") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_input.harvested_batch.crop_field
                              .name
                          }}
                        </dd>
                      </div>

                      <template v-if="process_line_exec_input.exported_batch">
                        <div class="sm:col-span-3">
                          <dt class="label-data">
                            {{ $t("labels.formalized_producer") }}
                          </dt>
                          <dd class="content-data">
                            {{
                              process_line_exec_input.exported_batch.producer
                                .producer_code
                            }}
                            -
                            {{
                              process_line_exec_input.exported_batch.producer
                                .fullname
                            }}
                          </dd>
                        </div>

                        <div class="sm:col-span-3">
                          <dt class="label-data">
                            {{ $t("labels.formalized_crop_field") }}
                          </dt>
                          <dd class="content-data">
                            {{
                              process_line_exec_input.exported_batch.crop_field
                                .name
                            }}
                          </dd>
                        </div>
                      </template>

                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.harvested_batch.crop_type") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_input.harvested_batch.crop_type
                              .name
                          }}
                        </dd>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel">
              <div class="panel-header">
                <h3 class="panel-header-title">Productos de salida</h3>
              </div>
              <div class="panel-body">
                <div class="space-y-8 divide-y divide-slate-200">
                  <div
                    v-for="process_line_exec_output in process_line_exec_step.process_line_exec_outputs"
                    class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                    :key="process_line_exec_output.id"
                  >
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{
                          $t(
                            "model.process_line_exec_output.process_line_product"
                          )
                        }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_output.process_line_product.name }}
                      </dd>
                    </div>
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.process_line_exec_output.output_code") }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_output.output_code }}
                      </dd>
                    </div>
                    <div class="sm:col-span-3">
                      <dt class="label-data">
                        {{ $t("model.process_line_exec_output.value") }}
                      </dt>
                      <dd class="content-data">
                        {{ process_line_exec_output.value }}
                        {{ process_line_exec_output.unit }}
                      </dd>
                    </div>
                    <div></div>
                    <template v-if="process_line_exec_output.exported_batch">
                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.exported_batch.producer") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_output.exported_batch.producer
                              .producer_code
                          }}
                          -
                          {{
                            process_line_exec_output.exported_batch.producer
                              .fullname
                          }}
                        </dd>
                      </div>
                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.exported_batch.crop_field") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_output.exported_batch.crop_field
                              .name
                          }}
                        </dd>
                      </div>
                      <div class="sm:col-span-3">
                        <dt class="label-data">
                          {{ $t("model.exported_batch.agro_exporter_process") }}
                        </dt>
                        <dd class="content-data">
                          {{
                            process_line_exec_output.exported_batch
                              .agro_exporter_process.name
                          }}
                        </dd>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions gap-x-2">
            <template
              v-for="report in process_line_step.process_line_step_reports"
              :key="report.id"
            >
              <white-button
                :label="report.name"
                :icon="
                  report.downloading ? 'fas fa-sync fa-spin' : 'fas fa-download'
                "
                @click.prevent="downloadReport(report)"
              />
            </template>
            <destroy-button
              v-if="!proc_button_destroy"
              :disabled_button="false"
              @destroyEvent="destroy"
              :label="$t('labels.destroy_button_label')"
              :title="$t('labels.destroy_button_title')"
              :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')"
            />
            <destroy-button-processing
              v-else
              :label="$t('labels.destroy_button_label')"
            />
            <edit-button @click.prevent="goToEditExecStep()" label="Editar" />
          </div>
        </div>
      </div>

      <div v-if="process_line_step_attrs.length > 0" class="mt-8 flex flex-col">
        <div class="flex flex-row justify-between mb-4">
          <h1 class="page-title">
            <i class="fa-solid"></i>
            {{ $t("labels.exec_attrs_title") }}
          </h1>
          <new-button
            @click.prevent="goToNewExecAttr"
            :label="$t('labels.new_exec_attr_button')"
          />
        </div>

        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                        $t(
                          "model.process_line_exec_attr.process_line_step_attr"
                        )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.process_line_exec_attr.value") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.process_line_exec_attr.unit") }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{ $t("model.process_line_exec_attr.observations") }}
                    </th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr
                    class="table-row"
                    v-for="process_line_step_attr in process_line_step_attrs"
                    :key="process_line_step_attr.id"
                  >
                    <td class="table-cell">
                      {{ process_line_step_attr.name }}
                    </td>
                    <td class="table-cell">
                      {{
                        process_line_exec_step.process_line_exec_attrs.find(
                          (exec_attr) =>
                            exec_attr.process_line_step_attr_id ==
                            process_line_step_attr.id
                        )?.value
                      }}
                    </td>
                    <td class="table-cell">
                      {{
                        process_line_exec_step.process_line_exec_attrs.find(
                          (exec_attr) =>
                            exec_attr.process_line_step_attr_id ==
                            process_line_step_attr.id
                        )?.unit
                      }}
                    </td>
                    <td class="table-cell">
                      {{
                        process_line_exec_step.process_line_exec_attrs.find(
                          (exec_attr) =>
                            exec_attr.process_line_step_attr_id ==
                            process_line_step_attr.id
                        )?.observations
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="process_line_step?.quality_templates?.length > 0" class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">Control de Calidad</h3>
        </div>
        <div class="panel-body">
          <div
            v-for="quality_template in process_line_step.quality_templates"
            :key="quality_template.id"
            class="flex flex-col gap-y-2 mb-4"
          >
            <span class="font-medium">{{
              quality_template.quality_template.name
            }}</span>

            <div
              v-for="harvested_batch in process_line_exec_step.harvested_batches"
              :key="harvested_batch.id"
              class="flex gap-x-4 align-middle items-center ml-4"
            >
              Lote: {{ harvested_batch.batch_code }}
              <new-button
                @click.prevent="
                  goToNewQualityInspect(quality_template.id, harvested_batch.id)
                "
                :label="$t('labels.new_quality_inspect_button')"
              />
              <new-button
                @click.prevent="
                  goToShowQualityInspects(
                    quality_template.id,
                    harvested_batch.id
                  )
                "
                :label="$t('labels.show_quality_inspects')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/exec_steps/show_exec_step.js";

export default {
  name: "PHProcessExecStepsShowExecStep",
  data() {
    return {
      packing_house_process: {},
      process_line_step: {},
      process_line_step_attrs: [],
      process_line_exec_step: {},
      load_general_data: false,
      proc_button_destroy: false,
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    process_line_step_id: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchProcessLineStep();
        this.fetchProcessLineStepAttrs();
        this.fetchProcessLineExecStep();
      });
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },

    fetchProcessLineStep: async function () {
      let response = await Requester.fetchProcessLineStep(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_step = response.data;
      this.process_line_step.process_line_step_reports.forEach((report) => {
        report.downloading = false;
      });
    },

    fetchProcessLineStepAttrs: async function () {
      let response = await Requester.fetchProcessLineStepAttrs(
        this.packing_house_id,
        this.process_line_step_id
      );
      this.process_line_step_attrs = response.data;
    },

    fetchProcessLineExecStep: async function () {
      const response = await Requester.fetchProcessLineExecStep(
        this.packing_house_id,
        this.id
      );
      this.process_line_exec_step = response.data;
      this.load_general_data = true;
    },

    destroy: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await Requester.destroy(this.packing_house_id, this.id);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowStep();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_button_destroy = false;
    },

    downloadReport: async function (process_line_step_report) {
      process_line_step_report.downloading = true;
      try {
        const response = await Requester.downloadReport(
          this.packing_house_id,
          this.id,
          process_line_step_report.id
        );
        let file = response.data;
        this.downloadFile(file, `${process_line_step_report.name}.pdf`);
      } catch (error) {
        error;
      } finally {
        process_line_step_report.downloading = false;
      }
    },

    goToShowStep: function () {
      this.$router.push({
        name: this.routeName("show_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: this.process_line_step_id,
        },
      });
    },

    goToNewExecAttr: function () {
      this.$router.push({
        name: this.routeName("new_exec_attr"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: this.process_line_step_id,
          id: this.id,
        },
      });
    },

    goToEditExecStep: function () {
      this.$router.push({
        name: this.routeName("edit_exec_step"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          process_line_step_id: this.process_line_step_id,
          id: this.id,
        },
      });
    },

    goToNewQualityInspect: function (quality_template_id, harvested_batch_id) {
      window.open(
        `/ph/${this.packing_house_id}/quality_control/process/${this.packing_house_process_id}/new_inspect/${harvested_batch_id}/${quality_template_id}/`,
        "_blank"
      );
    },

    goToShowQualityInspects: function (
      quality_template_id,
      harvested_batch_id
    ) {
      window.open(
        `/ph/${this.packing_house_id}/quality_control/process/${this.packing_house_process_id}/list_inspects/${harvested_batch_id}/${quality_template_id}/`,
        "_blank"
      );
    },
  },
};
</script>
